import React from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { selectData } from 'layouts/onboarding'

import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

function Union({
  collapseSections,
  toggleCollapse,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse in={collapseSections.union} style={{ width: '100%' }}>
                {/* Value Points Here */}
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="union"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('union')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Union Affiliation
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.union
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.union} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'unionAffiliation',
                  label: 'Union Affiliation',
                  placeholder: 'Union Affiliation',
                  inputType: 'select',
                  value: intakeState.unionAffiliation,
                  onChange: updateIntakeStateAndSubmit((unionAffiliation) =>
                    updateIntakeStateAtKey({
                      unionAffiliation,
                    })
                  ),
                  options: selectData.unionAffiliation,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'unionLocal',
                  label: 'Union Local',
                  placeholder: 'Union Local',
                  inputType: 'select',
                  searchable: true,
                  value: intakeState.unionLocal,
                  onChange: updateIntakeStateAndSubmit((unionLocal) =>
                    updateIntakeStateAtKey({
                      unionLocal,
                    })
                  ),
                  options: selectData.unionLocal,
                })}
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Union
